import React, { useState } from 'react';
import DevaiceDetails from '../../pages/devices/details/DevaiceDetails';
import DetailEvents from '../../pages/devices/details/DeviceEvents';
import DevicesMessages from '../../pages/devices/details/DeviceMessages';
import { useTranslation } from 'react-i18next';
export type TabType = 'details' | 'events' | 'messages';

interface TabPanelProps {
    deviceName: string;
    events: DeviceEvent[];
    openDeleteModal: () => void;
    openConectionSettings: () => void
}
export interface DeviceEvent {
    id: string;
    timestamp: string;
    event_type: string;
}

export const TabPanel: React.FC<TabPanelProps> = ({ openDeleteModal, openConectionSettings }) => {
    const [activeTab, setActiveTab] = useState<TabType>('details');
    const { t } = useTranslation()

    const i18nDeviceDirectory = (key: string): string =>
        t(`device-directory.${key}`);

    const tabs = [
        { id: 'details' as TabType, label: 'device-details' },
        { id: 'events' as TabType, label: 'device-events' },
        { id: 'messages' as TabType, label: 'int-messages' },
    ];

    return (
        <div className="w-full h-full bg-white shadow-sm flex flex-col">
            <div className="flex flex-shrink-0">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`
                         justify-start py-2 text-sm font-medium transition-colors
                         ${activeTab === tab.id
                                ? 'text-primeblue border-b-2 border-primeblue'
                                : 'text-primary-light hover:text-gray-800 hover:bg-gray-50'
                            }
                        ${tab.id === 'details' ? 'w-[134px]' : ''}
                        ${tab.id === 'events' ? 'w-[132px]' : ''}
                        ${tab.id === 'messages' ? 'w-[185px]' : ''}
      `}
                    >
                        {i18nDeviceDirectory(tab.label)}
                    </button>
                ))}
            </div>

            <div className="flex-1 overflow-y-auto min-h-0">

                {activeTab === 'details' && (
                    <DevaiceDetails openConectionSettings={openConectionSettings} openDeleteModal={openDeleteModal} />
                )}

                {activeTab === 'events' && (
                    <DetailEvents />
                )}
                {activeTab === 'messages' && (
                    <DevicesMessages />
                )}
            </div>
        </div>
    );
};